import { useEffect, useRef, useState } from "react";
import axios from "axios";

import { useNavigate } from "react-router-dom";
import Footer from "../Components/Footer";

import { Anchor, Ship, Zap, Users, Compass, Waves } from "lucide-react";
import "swiper/css";
import "swiper/css/navigation";
import { PartyPopper, Briefcase, ArrowRight } from "lucide-react";
import {
  Award,
  Shield,
  ThumbsUp,
  Sparkles,
  CreditCard,
  MapPin,
} from "lucide-react";
import PremiumNavbar from "../Components/PremiumNavbar";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";

export default function Home() {
  const iconMap = {
    Anchor,
    Waves,
    Zap,
    Users,
  };

  // Video Slider State
  const [activeVideoIndex, setActiveVideoIndex] = useState(0);
  const [isMuted, setIsMuted] = useState(true);
  const [isVideoPlaying, setIsVideoPlaying] = useState(true);
  const videoRef = useRef(null);

  // Google Reviews Slider State
  const [activeReviewIndex, setActiveReviewIndex] = useState(0);
  const [isReviewAutoPlay, setIsReviewAutoPlay] = useState(true);

  const [mostLovedExperiences, setMostLovedExperiences] = useState(null);

  const [mostLovedLoading, setMostLovedLoading] = useState(true);

  const defaultVideoTestimonials = [
    {
      guestName: "Priya & Vikram Malhotra",
      location: "Mumbai Coast",
      experience: "Private Yacht Sunset Charter",
      videoUrl: "/assets/img/yacht_video.mp4",
      poster: "yacht_video.mp4",
    },
    {
      guestName: "Arjun & Friends",
      location: "Goa Waters",
      experience: "Birthday Celebration on Catamaran",
      videoUrl: "/assets/img/yacht_video2.mp4",
      poster: "yacht_video2.mp4",
    },
    {
      guestName: "Siddharth & Natasha",
      location: "Elephanta Route",
      experience: "Romantic Proposal Cruise",
      videoUrl: "/assets/img/yacht_video.mp4",
      poster: "yacht_video.mp4",
    },
  ];

  const [videoTestimonials, setVideoTestimonials] = useState(
    defaultVideoTestimonials
  );

  useEffect(() => {
    const fetchMostLovedExperiences = async () => {
      try {
        const response = await fetch(
          "/api/most-loved-experiences",
        );

        if (!response.ok) {
          throw new Error("Failed to fetch Most Loved Experiences");
        }

        const data = await response.json();

        setMostLovedExperiences(data);
      } catch (error) {
        console.error("Most Loved Experiences error:", error);
      } finally {
        setMostLovedLoading(false);
      }
    };

    fetchMostLovedExperiences();
  }, []);

  useEffect(() => {
    const fetchTestimonialVideos = async () => {
      try {
        const response = await fetch(
          "/api/testimonial-videos"
        );

        if (!response.ok) {
          throw new Error("Failed to fetch Testimonial Videos");
        }

        const data = await response.json();

        if (Array.isArray(data.videos)) {
          setVideoTestimonials(data.videos);
          setActiveVideoIndex(0);
        }
      } catch (error) {
        console.error("Testimonial Videos error:", error);
      }
    };

    fetchTestimonialVideos();
  }, []);

  // Google Reviews Data Array (Update this array as needed)
  const googleReviews = [
    {
      id: 1,
      name: "Rohan Sharma",
      userImage:
        "https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=120&q=80",
      rating: 5,
      timeAgo: "2 weeks ago",
      packageType: "Mumbai to Mandwa Day Package",
      review:
        "An absolute 5-star experience! The yacht was pristine, the booking process was seamless, and the captain was very professional. Watching the sunset while cruising back to Gateway of India was unforgettable.",
    },
    {
      id: 2,
      name: "Ananya Deshmukh",
      userImage:
        "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=120&q=80",
      rating: 5,
      timeAgo: "1 month ago",
      packageType: "Elephanta Island Expedition",
      review:
        "Indiaboats handled every detail of our family outing with utmost care. Safety was clearly top priority. The guide was extremely knowledgeable and the boat ride was super comfortable!",
    },
    {
      id: 3,
      name: "Karan Singhania",
      userImage:
        "https://images.unsplash.com/photo-1517841905240-472988babdf9?auto=format&fit=crop&w=120&q=80",
      rating: 5,
      timeAgo: "3 weeks ago",
      packageType: "Sunset Sail Experience",
      review:
        "Booked a surprise birthday sailing trip for my wife. The team was extraordinarily helpful with arrangements onboard. Outstanding hospitality and luxury feeling throughout!",
    },
    {
      id: 4,
      name: "Meera Nair",
      userImage:
        "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=120&q=80",
      rating: 5,
      timeAgo: "2 months ago",
      packageType: "Goa Coastal Cruise",
      review:
        "Remarkable service! The booking team gave us clear advice on which boat suited our group size best. Everything went exactly as scheduled. Highly recommended for anyone visiting Goa.",
    },
  ];

  const differentiatorsList = [
    {
      id: "01",
      title: "One of the Largest Yacht & Boat Fleets in Mumbai & Goa",
      desc: "Choose from sailing yachts, luxury motor yachts, catamarans, party yachts and speed boats for small private groups, families, celebrations and large corporate events.",
      icon: <Ship size={24} />,
    },
    {
      id: "02",
      title: "Safety First, Always",
      desc: "Your safety is our highest priority. All charters operate with trained crew, certified safety equipment, life jackets and professionally maintained vessels. We follow strict operational and safety procedures for every trip.",
      icon: <Shield size={24} />,
    },
    {
      id: "03",
      title: "Experienced & Professional Crew",
      desc: "Our skippers and crew members are trained professionals with extensive local knowledge and experience operating in Mumbai Harbour, Mandwa, Alibaug, Elephanta and Goa waters.",
      icon: <Compass size={24} />,
    },
    {
      id: "04",
      title: "Transparent Pricing – No Hidden Charges",
      desc: "Clear pricing, detailed inclusions and honest recommendations help you choose the right yacht or boat without unexpected costs.",
      icon: <CreditCard size={24} />,
    },
    {
      id: "05",
      title: "Specialists in Private & Corporate Events",
      desc: "From birthday parties, anniversaries and family outings to corporate sailing regattas, team-building programmes and client entertainment events, we create customised experiences for every occasion.",
      icon: <Award size={24} />,
    },
    {
      id: "06",
      title: "Convenient Speed Boat Transfers",
      desc: "Avoid road traffic and travel quickly between Mumbai, Mandwa, Alibaug and Elephanta Island with our private and shared speed boat transfer services.",
      icon: <Zap size={24} />,
    },
    {
      id: "07",
      title: "Personalised Service from Enquiry to Departure",
      desc: "Our team assists with boat selection, event planning, catering, decorations, entertainment and logistics to ensure a smooth experience from booking to boarding.",
      icon: <Sparkles size={24} />,
    },
    {
      id: "08",
      title: "Trusted by Families, Tourists & Corporate Clients",
      desc: "Over the years, India Boats has helped thousands of guests enjoy memorable experiences on the water through professional service, reliable operations and a commitment to customer satisfaction.",
      icon: <ThumbsUp size={24} />,
    },
  ];

  const yachtServiceOfferings = [
    {
      id: "01",
      category: "Private Yacht Charters",
      headline: "Private Yacht Charters",
      suitability: "Best For: Couples, small families, or birthday dinners.",
      description:
        "Experience the Arabian Sea on your own terms. Whether it's a romantic sunset or a family brunch, our premium fleet offers the privacy and elegance you deserve.",
      imgUrl: "assets/img/img1.png",
      pagelink: "/birthdayLanding",
      icon: <Ship size={20} />,
    },
    {
      id: "02",
      category: "Celebrations",
      headline: "Yacht  Parties",
      suitability: "Best For: Large birthdays, bachelorettes, and weddings.",
      description:
        "Why stay on land when you can party on the waves? From DJ setups to gourmet catering, we provide the space and the vibe for your biggest milestones.",
      imgUrl: "assets/img/img2.png",
      pagelink: "/birthdayLanding",
      icon: <PartyPopper size={20} />,
    },
    {
      id: "03",
      category: "Logistics",
      headline: "Speedboat Transfers",
      suitability:
        "Best For: Travelers going to Alibaug/Mandwa or Elephanta Caves.",
      description:
        "Save time without sacrificing comfort. Our private speedboats offer the fastest, most stylish way to cross from Mumbai to Mandwa in just 20 minutes.",
      imgUrl: "assets/img/img3.png",
      pagelink: "/speedboatTransfers",
      icon: <Zap size={20} />,
    },
    {
      id: "04",
      category: "Corporate",
      headline: "Corporate Sailing & Events",
      suitability: "Best For: HR Managers, CEOs, and Team Leads.",
      description:
        "From competitive regattas that build teamwork to grand product launches on the water—elevate your brand and reward your team with an unforgettable maritime experience.",
      imgUrl: "assets/img/img1.png",
      pagelink: "/corporateLanding",
      icon: <Briefcase size={20} />,
    },
  ];

  const routes = [
    {
      label: "Express Route 01",
      path: ["Mumbai", "Mandwa"],
      details: "One-Way / Same-Day Return",
      tag: "Frequent",
    },
    {
      label: "Express Route 02",
      path: ["Mumbai", "Elephanta"],
      details: "Return only or guided option",
      tag: "Tour",
    },
  ];

  const capacities = [
    { size: "6", type: "Seater Express" },
    { size: "8", type: "Seater Express" },
    { size: "10", type: "Seater Express" },
    { size: "12", type: "Seater Express" },
    { size: "18", type: "Seater Express" },
    { size: "50", type: "Fast Ferry" },
  ];

  // const customPillarsData = [
  //   {
  //     id: "01",
  //     title: "Birthday & Anniversary Yacht Celebrations",
  //     tagline:
  //       "Celebrate life’s special moments on a private yacht with stunning sea views, personalized setups and unforgettable memories on the water.",
  //     desc: "Cake, music, and the ocean breeze.",
  //     footer: "Perfect for All Ages",
  //     icon: <Users size={32} />,
  //     image: "assets/img/birthday-card.jpeg",
  //     pagename: "birthday-anniversary-yacht-celebration-mumbai",
  //   },
  //   {
  //     id: "02",
  //     title: "Pre-Wedding Yacht Photo Shoots",
  //     tagline:
  //       "Capture your love story with a breathtaking ocean backdrop, elegant yacht settings and timeless moments you’ll cherish forever.",
  //     desc: "Stunning photos and romantic views you'll keep forever.",
  //     footer: "Exclusive & Scenic",
  //     icon: <Compass size={32} />,
  //     image: "assets/img/pre-wedding-photo.jpeg",
  //     pagename: "pre-wedding-yacht-photoshoot-mumbai",
  //   },
  //   {
  //     id: "03",
  //     title: "Family & Private Yacht Party Experiences",
  //     tagline:
  //       "Enjoy quality time with your loved ones on a private yacht, away from the crowds, with comfort, privacy and beautiful sea views.",
  //     desc: "No crowds. No noise. Just you and your loved ones.",
  //     footer: "Up to 15 Guests",
  //     icon: <Anchor size={32} />,
  //     image: "assets/img/family-party.jpeg",
  //     pagename: "family-private-yacht-party-mumbai",
  //   },
  //   {
  //     id: "04",
  //     title: "Corporate Sailing Regattas",
  //     tagline:
  //       "Build teamwork, leadership and communication through an exciting on-water experience designed for corporate teams and business groups.",
  //     desc: "A fun, competitive way to bond outside the office.",
  //     footer: "Team Building & Action",
  //     icon: <Zap size={32} />,
  //     image: "assets/img/corporate-regatta.jpeg",
  //     pagename: "corporate-sailing-regatta-mumbai",
  //   },
  //   {
  //     id: "05",
  //     title: "Corporate Yacht Events & Networking",
  //     tagline:
  //       "Impress clients, partners and teams with a distinctive business event experience on the water.",
  //     desc: "The ultimate 'power move' for meetings and business mixers.",
  //     footer: "15+ Guests / Business Class",
  //     icon: <Users size={32} />,
  //     image: "assets/img/networking2.png",
  //     pagename: "corporate-events-networking-yacht-mumbai",
  //   },
  //   {
  //     id: "06",
  //     title: "Alibaug & Elephanta Boat Tours",
  //     tagline:
  //       "Escape the city with quick island getaways and scenic boat experiences from Mumbai to Alibaug and Elephanta.",
  //     desc: "Skip the traffic. Explore Mumbai’s best islands in style.",
  //     footer: "Day Trips & Sightseeing",
  //     icon: <Ship size={32} />,
  //     image: "assets/img/alibaug-elephanta.jpeg",
  //     pagename: "alibaug-elephanta-boat-tours-mumbai",
  //   },
  // ];

  const pillars = [
    {
      id: "01",
      title: "Birthday & Anniversary Yacht Celebrations",
      tagline:
        "Celebrate life’s special moments on a private yacht with stunning sea views, personalized setups and unforgettable memories on the water.",
      desc: "Cake, music, and the ocean breeze.",
      footer: "Perfect for All Ages",
      icon: <Users size={36} />,
      image: "assets/img/birthday-card.jpeg",
      pagename: "birthday-anniversary-yacht-celebration-mumbai",
    },
    {
      id: "02",
      title: "Pre-Wedding Yacht Photo Shoots",
      tagline:
        "Capture your love story with a breathtaking ocean backdrop, elegant yacht settings and timeless moments you’ll cherish forever.",
      desc: "Stunning photos and romantic views you'll keep forever.",
      footer: "Exclusive & Scenic",
      icon: <Compass size={36} />,
      image: "assets/img/pre-wedding-photo.jpeg",
      pagename: "pre-wedding-yacht-photoshoot-mumbai",
    },
    {
      id: "03",
      title: "Family & Private Yacht Party Experiences",
      tagline:
        "Enjoy quality time with your loved ones on a private yacht, away from the crowds, with comfort, privacy and beautiful sea views.",
      desc: "No crowds. No noise. Just you and your loved ones.",
      footer: "Up to 15 Guests",
      icon: <Anchor size={36} />,
      image: "assets/img/family-party.jpeg",
      pagename: "family-private-yacht-party-mumbai",
    },
    {
      id: "04",
      title: "Corporate Sailing Regattas",
      tagline:
        "Build teamwork, leadership and communication through an exciting on-water experience designed for corporate teams and business groups.",
      desc: "A fun, competitive way to bond outside the office.",
      footer: "Team Building & Action",
      icon: <Zap size={36} />,
      image: "assets/img/corporate-regatta.jpeg",
      pagename: "corporate-sailing-regatta-mumbai",
    },
    {
      id: "05",
      title: "Corporate Yacht Events & Networking",
      tagline:
        "Impress clients, partners and teams with a distinctive business event experience on the water.",
      desc: "The ultimate 'power move' for meetings and business mixers.",
      footer: "15+ Guests / Business Class",
      icon: <Users size={36} />,
      image: "assets/img/testBoat.png",
      pagename: "corporate-events-networking-yacht-mumbai",
    },
    {
      id: "06",
      title: "Alibaug & Elephanta Boat Tours",
      tagline:
        "Escape the city with quick island getaways and scenic boat experiences from Mumbai to Alibaug and Elephanta.",
      desc: "Skip the traffic. Explore Mumbai’s best islands in style.",
      footer: "Day Trips & Sightseeing",
      icon: <Ship size={36} />,
      image: "assets/img/alibaug-elephanta.jpeg",
      pagename: "alibaug-elephanta-boat-tours-mumbai",
    },
  ];

  // const Newpillars = [
  //   {
  //     title: "Private Yacht Charters",
  //     desc: "Just You, Your Favorite People, and the Open Sea..",
  //     capacity: "Up to 15 Guests",
  //     icon: <Anchor size={36} />,
  //     id: "01",
  //     image: "assets/img/img2.png",
  //     pagename: "private-yacht-charter-mumbai-goa"
  //   },
  //   {
  //     title: "Yacht  Parties",
  //     desc: "The Ultimate Venue for Grand Celebrations and Floating Events.",
  //     capacity: "15+ Guests",
  //     icon: <Waves size={36} />,
  //     id: "02",
  //     image: "assets/img/img3.png",
  //     pagename: "yacht-party-mumbai"
  //   },
  //   {
  //     title: "Speedboat Transfers",
  //     desc: "Swift, Private, and Seamless Connectivity to Mandwa & Elephanta",
  //     capacity: "Quick & Efficient",
  //     icon: <Zap size={36} />,
  //     id: "03",
  //     image: "assets/img/img4.png",
  //     pagename: "SpeedBoat"
  //   },
  //   {
  //     title: "Corporate Sailing & Events",
  //     desc: "Boost Morale with Regattas and Elite Business Networking.",
  //     capacity: "Custom corporate, B2B and B2C solutions",
  //     icon: <Users size={36} />,
  //     id: "04",
  //     image: "assets/img/img1.png",
  //     pagename: "CorporateEvents"
  //   }
  // ];
  const API_URL = process.env.REACT_APP_API_BASE_URL;
  const Img_URL = process.env.REACT_APP_Img_BASE_URL;
  const [boatData, setBoatData] = useState([]);
  const [sliders, setSliders] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchSliders = async () => {
      try {
        const response = await axios.get(`${API_URL}Home/GetSlider`);
        if (response.data.success) {
          setSliders(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching sliders:", error);
      }
    };

    fetchSliders();
  }, []);

  useEffect(() => {
    const fetchBoats = async () => {
      try {
        const res = await fetch(`${API_URL}Boat/GetBoatMaster`);
        const data = await res.json();
        if (data.success) {
          setBoatData(data.data);
        }
      } catch (err) {
        console.error("Error fetching boats:", err);
      }
    };

    fetchBoats();
  }, []);

  const groupedBoats = boatData.reduce((acc, item) => {
    const key = item.subCategoryName || "Other";

    if (!acc[key]) {
      acc[key] = {
        boats: [],
        categoryName: item.categoryName,
        locationName: item.locationName,
        placeName: item.placeName,
        typeOfBoatName: item.typeOfBoatName,
        typeOfYachtName: item.typeOfYachtName,
      };
    }

    if (acc[key].boats.length < 10) {
      const imageUrl = item.boatMaster?.primeryImage
        ? `http://uat.indiaboats.in/images/Boat/${item.boatMaster.primeryImage}`
        : "http://uat.indiaboats.in/assets/img/boat1.jpg";

      acc[key].boats.push({
        id: item.boatMaster?.id || 0,
        title: item.boatMaster?.boatName || "No Name",
        desc: `${item.locationName || ""} - ${item.placeName || ""}`,
        img: imageUrl,
      });
    }

    return acc;
  }, {});

  // Handle video auto-play & advance
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current
        .play()
        .then(() => {
          setIsVideoPlaying(true);
        })
        .catch(() => {
          setIsVideoPlaying(false);
        });
    }
  }, [activeVideoIndex, videoTestimonials]);

  // Video navigation handlers
  const handleNextVideo = () => {
    if (!videoTestimonials.length) {
      return;
    }

    setActiveVideoIndex((prev) => (prev + 1) % videoTestimonials.length);
  };

  const handlePrevVideo = () => {
    if (!videoTestimonials.length) {
      return;
    }

    setActiveVideoIndex(
      (prev) =>
        (prev - 1 + videoTestimonials.length) % videoTestimonials.length,
    );
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  const togglePlayPause = () => {
    if (videoRef.current) {
      if (isVideoPlaying) {
        videoRef.current.pause();
        setIsVideoPlaying(false);
      } else {
        videoRef.current.play();
        setIsVideoPlaying(true);
      }
    }
  };

  useEffect(() => {
    if (!isReviewAutoPlay) return;
    const interval = setInterval(() => {
      setActiveReviewIndex((prev) => (prev + 1) % googleReviews.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [isReviewAutoPlay, googleReviews.length]);

  const handleNextReview = () => {
    setActiveReviewIndex((prev) => (prev + 1) % googleReviews.length);
  };

  const handlePrevReview = () => {
    setActiveReviewIndex(
      (prev) => (prev - 1 + googleReviews.length) % googleReviews.length,
    );
  };

  const activeVideo = videoTestimonials[activeVideoIndex];
  const activeReview = googleReviews[activeReviewIndex];

  const [signatureExperience, setSignatureExperience] = useState(null);

  const getHeroVideoSrc = (videoPath) => {
    if (!videoPath) {
      return "/assets/img/hero/hero-video.mp4";
    }

    if (videoPath.startsWith("http")) {
      return videoPath;
    }

    if (videoPath.startsWith("/uploads/")) {
      return `${videoPath}`;
    }

    return videoPath;
  };

  const getTestimonialVideoSrc = (videoPath) => {
    if (!videoPath) {
      return "";
    }

    if (videoPath.startsWith("http")) {
      return videoPath;
    }

    if (videoPath.startsWith("/uploads/")) {
      return `${videoPath}`;
    }

    return videoPath;
  };

  const heroVideoSrc = getHeroVideoSrc(signatureExperience?.video);

  useEffect(() => {
    fetch("/api/signature-experience")
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch Signature Experience");
        }

        return res.json();
      })
      .then((data) => {
        setSignatureExperience(data);
      })
      .catch((error) => {
        console.error("Signature Experience API error:", error);
      });
  }, []);

  return (
    <>
      {/* Header */}
      {/* <Header /> */}
      <IndiaBoatsTopBar />
      <PremiumNavbar />
      <>
        <section className="idx-section" id="destination-sec">
          <div className="idx-video-container">
            <video
              className="idx-video-bg"
              autoPlay
              muted
              loop
              playsInline
              key={heroVideoSrc}
              src={heroVideoSrc}
            />
            <div className="idx-overlay" />
          </div>

          <div className="idx-container">
            <div className="idx-header">
              <h2 className="idx-main-title">
                {signatureExperience?.sectionTitle}
              </h2>
              <section className="idx-pillar-wrapper1">
                <div className="container">
                  <div className="row">
                    {signatureExperience?.pillars?.map((pillar, index) => (
                      <div
                        key={index}
                        className="col-lg-3 col-md-4 col-sm-6 col-12"
                      >
                        <div
                          className="idx-pillar-item"
                          onClick={() => navigate(`/${pillar.pagename}`)}
                          style={{ cursor: "pointer" }}
                        >
                          <div
                            className="idx-item-bg-image"
                            style={{
                              backgroundImage: `url(${
                                pillar.image?.startsWith("http")
                                  ? pillar.image
                                  : `${pillar.image}`
                              })`,
                            }}
                          ></div>

                          <div className="idx-item-overlay"></div>

                          <div className="idx-item-inner">
                            <div className="idx-item-header">
                              <span className="idx-item-number"></span>

                              <div className="idx-item-icon">
                                {(() => {
                                  const IconComponent = iconMap[pillar.icon];

                                  return IconComponent ? (
                                    <IconComponent size={36} />
                                  ) : null;
                                })()}
                              </div>
                            </div>

                            <div className="idx-item-body">
                              <h3 className="idx-item-title">{pillar.title}</h3>
                              <p className="idx-item-desc">{pillar.desc}</p>
                              <div className="idx-item-capacity">
                                {pillar.capacity}
                              </div>
                            </div>

                            <div className="idx-item-footer">
                              <div className="idx-btn">
                                <span className="idx-explore-text">
                                  Book Now
                                </span>
                              </div>
                              <div className="idx-explore-circle">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 24 24"
                                  stroke="white"
                                  fill="none"
                                >
                                  <line x1="5" y1="12" x2="19" y2="12"></line>
                                  <polyline points="12 5 19 12 12 19"></polyline>
                                </svg>
                              </div>
                            </div>
                          </div>

                          <div className="idx-item-hover-bg"></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>

        <section className="mis-welcome-section">
          <div className="mis-container">
            {/* Asymmetrical Split Layout */}
            <div className="mis-split-grid">
              {/* Left Column: Bold Editorial Heading & Image */}
              <div className="mis-left-column">
                <h1 className="mis-section-title">
                  Luxury Yacht Charters,{" "}
                  <span className="mis-light-text">
                    Speed Boat Transfers & Corporate Sailing Experiences in
                    Mumbai & Goa
                  </span>
                </h1>

                {/* Visual Graphic Element */}
                <div className="mis-visual-frame">
                  <img
                    src="assets/img/Luxury_Yacht_Charters.png"
                    alt="Luxury Yacht Cruising Mumbai Coast"
                    className="mis-visual-img"
                  />
                  {/* <div className="mis-floating-card">
                <span className="mis-card-stat">100%</span>
                <span className="mis-card-label">Tailored Charters</span>
              </div> */}
                </div>
              </div>

              {/* Right Column: Narrative Copy Pillars */}
              <div className="mis-right-column">
                {/* Core Overview Block */}
                <div className="mis-narrative-block mis-lead-block">
                  <p className="mis-paragraph-lead">
                    Welcome to India Boats, your trusted partner for luxury
                    yacht charters, private yacht parties, speed boat transfers
                    and sailing experiences in Mumbai and Goa. Whether you are
                    planning a birthday celebration, anniversary, family outing,
                    sunset cruise, pre-wedding photoshoot, corporate event or a
                    private day on the water, we help you create memorable
                    experiences at sea.
                  </p>
                </div>

                {/* Strategic Pillars Grid */}
                <div className="mis-pillars-stack">
                  {/* Fleet & Transit Pillar */}
                  <div className="mis-pillar-card">
                    <div className="mis-pillar-icon-box">
                      <Ship size={20} />
                    </div>
                    <div className="mis-pillar-content">
                      <h3 className="mis-pillar-title">
                        Our Fleet & Island Transfers
                      </h3>
                      <p className="mis-pillar-desc">
                        Our fleet includes sailing yachts, luxury motor yachts,
                        catamarans, party yachts and high-speed boats for
                        private charters and transfers. We also offer convenient
                        speed boat services between Mumbai, Mandwa, Alibaug and
                        Elephanta Island, providing a faster and more enjoyable
                        way to travel.
                      </p>
                    </div>
                  </div>

                  {/* Corporate Sailing Pillar */}
                  <div className="mis-pillar-card">
                    <div className="mis-pillar-icon-box">
                      <Award size={20} />
                    </div>
                    <div className="mis-pillar-content">
                      <h3 className="mis-pillar-title">
                        Corporate Regattas & Events
                      </h3>
                      <p className="mis-pillar-desc">
                        For corporate groups, we specialise in sailing regattas,
                        team-building activities, leadership programmes and
                        client entertainment events that combine learning,
                        competition and fun on the water.
                      </p>
                    </div>
                  </div>

                  {/* Uncompromising Safety Pillar */}
                  <div className="mis-pillar-card">
                    <div className="mis-pillar-icon-box">
                      <Shield size={20} />
                    </div>
                    <div className="mis-pillar-content">
                      <h3 className="mis-pillar-title">
                        Uncompromising Safety & Standards
                      </h3>
                      <p className="mis-pillar-desc">
                        Safety remains our highest priority. Every charter is
                        operated by trained crew, professionally maintained
                        vessels and certified safety equipment, ensuring a safe
                        and enjoyable experience for every guest. Combined with
                        transparent pricing, personalised service and one of the
                        largest charter fleets in Mumbai and Goa, India Boats
                        delivers unforgettable experiences on the sea for
                        families, friends, tourists and businesses alike.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Elegant Call to Action */}
                {/* <div className="mis-action-row">
              <button className="mis-action-btn">
                <span>Plan Your Voyage</span>
                <div className="mis-btn-arrow-box">
                  <ArrowRight size={14} />
                </div>
              </button>
            </div> */}
              </div>
            </div>
          </div>
        </section>

        <section className="tdg-main-section">
          <div className="tdg-container">
            {/* Editorial Section Header */}
            <div className="tdg-header-block">
              <div className="tdg-badge-row">
                <Anchor size={14} className="tdg-badge-icon" />
                <span className="tdg-pre-title">Why Us</span>
              </div>

              <h2 className="tdg-section-title">
                Why Choose India Boats for Yacht Charters, Speed Boat Transfers
                & Corporate Sailing Events?
              </h2>

              {/* Paragraph text centered and elegantly bounded */}
              <div className="tdg-intro-wrapper">
                <p className="tdg-intro-text">
                  Whether you are booking a luxury yacht charter in Mumbai,
                  planning a private yacht party in Goa, arranging a speed boat
                  transfer to Alibaug or organising a corporate sailing event,
                  choosing the right operator makes all the difference. At India
                  Boats, we combine premium boats, experienced crew, transparent
                  pricing and industry-leading safety standards to deliver
                  exceptional experiences on the water. Our focus is simple —
                  helping every guest enjoy the sea safely, comfortably and
                  confidently.
                </p>
              </div>

              <div className="tdg-title-divider"></div>
            </div>

            {}
            <div className="tdg-cards-grid">
              {differentiatorsList.map((item, index) => (
                <div key={index} className="tdg-card">
                  {/* Decorative top border line matching brand styles */}
                  <div className="tdg-card-top-accent"></div>

                  <div className="tdg-card-header">
                    {/* Custom Styled Icon Box */}
                    <div className="tdg-icon-box">{item.icon}</div>
                    {/* Numeric Indicator */}
                    {/* <span className="tdg-card-num">{item.id}</span> */}
                  </div>

                  {/* Card Body Contents */}
                  <div className="tdg-card-body">
                    <h3 className="tdg-card-title">{item.title}</h3>
                    <p className="tdg-card-desc">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="mcp-section">
          <div className="mcp-container">
            {}
            <div className="mcp-section-header">
              <div className="mcp-badge">
                <Anchor size={14} className="mcp-badge-icon" />
                <span> {mostLovedExperiences?.badge}</span>
              </div>
              <h2 className="mcp-main-title">
                {mostLovedExperiences?.mainTitle}{" "}
                <span className="mcp-accent-title">
                  {mostLovedExperiences?.accentTitle}
                </span>
              </h2>
              <p className="mcp-subtitle">{mostLovedExperiences?.subtitle}</p>
              <div className="mcp-divider"></div>
            </div>

            {}
            <div className="mcp-grid">
              {mostLovedExperiences?.cards?.map((pillar) => (
                <div key={pillar.id} className="mcp-card">
                  {/* Default State Background Image */}
                  <div
                    className="mcp-card-bg"
                    style={{
                      backgroundImage: `url(${
                        pillar.image?.startsWith("http")
                          ? pillar.image
                          : pillar.image?.startsWith("/uploads/")
                            ? `${pillar.image}`
                            : pillar.image
                      })`,
                    }}
                  ></div>

                  {/* Default State Image Text Vignette (For high-contrast text rendering) */}
                  <div className="mcp-card-vignette"></div>

                  {/* Default State Title Block (Visible initially, fades on hover) */}
                  <div className="mcp-default-content">
                    {/* <span className="mcp-default-num">{pillar.id}</span> */}
                    <h3 className="mcp-default-title">{pillar.title}</h3>
                  </div>

                  {/* Dynamic Slide-Up Solid Color Overlay Layer (Exact specified color: #2a4366) */}
                  <div className="mcp-slide-overlay"></div>

                  {/* Hover Showcase Content Block (Fades in over slide-up layer) */}
                  <div className="mcp-hover-content">
                    <div className="mcp-hover-top">
                      <div className="mcp-hover-header"> 
                        {/* <span className="mcp-hover-num">{pillar.id}</span> */}
                        {/* <div className="mcp-hover-icon">{pillar.icon}</div> */}
                      </div>

                      <h4 className="mcp-hover-title">{pillar.title}</h4>
                      <p className="mcp-hover-tagline">{pillar.tagline}</p>
                      <p className="mcp-hover-desc">"{pillar.desc}"</p>
                    </div>

                    <div className="mcp-hover-bottom">
                      {/* <div className="mcp-hover-footer-meta">
                    <span className="mcp-footer-dot"></span>
                    <span>{pillar.footer}</span>
                  </div> */}

                      <a
                        href={`/${pillar.pagename}`}
                        className="mcp-explore-btn"
                      >
                        <span>{pillar.buttonText}</span>

                        <ArrowRight size={14} />
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="ib-tm-section">
          <div className="ib-tm-container">
            {/* Section Header */}
            <div className="ib-tm-header">
              <span className="ib-tm-subtitle">Guest Stories & Reviews</span>
              <h2 className="ib-tm-title">Real Experiences On The Water</h2>

              <p className="ib-tm-desc">
                Discover why guests, families, and private charters trust
                Indiaboats for safe, seamless, and unforgettable moments across
                Mumbai and Goa.
              </p>
            </div>

            {/* Testimonials 2-Column Grid */}
            <div className="ib-tm-grid">
              {/* LEFT COLUMN: Video Testimonial Slider */}
              <div className="ib-tm-video-card">
                <div className="ib-tm-video-wrapper">
                  <video
                    key={`${activeVideoIndex}-${activeVideo?.videoUrl || ""}`}
                    ref={videoRef}
                    className="ib-tm-video-element"
                    src={getTestimonialVideoSrc(activeVideo?.videoUrl)}
                    poster={activeVideo?.poster}
                    playsInline
                    muted={isMuted}
                    onEnded={handleNextVideo}
                  />

                  <div className="ib-tm-video-overlay">
                    <span className="ib-tm-video-top-tag">Video Story</span>

                    <div className="ib-tm-video-details">
                      <h3 className="ib-tm-video-guest">
                        {activeVideo?.guestName}
                      </h3>
                      <p className="ib-tm-video-meta">
                        {" "}
                        <MapPin size={20} /> {activeVideo?.location}
                        {activeVideo?.experience
                          ? ` • ${activeVideo.experience}`
                          : ""}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Video Controls Bar */}
                <div className="ib-tm-video-controls">
                  <div className="ib-tm-ctrl-group">
                    {/* Play / Pause Toggle */}
                    <button
                      className="ib-tm-btn-icon"
                      onClick={togglePlayPause}
                      aria-label={isVideoPlaying ? "Pause Video" : "Play Video"}
                      title={isVideoPlaying ? "Pause" : "Play"}
                    >
                      {isVideoPlaying ? (
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <rect x="6" y="4" width="4" height="16" rx="1"></rect>
                          <rect
                            x="14"
                            y="4"
                            width="4"
                            height="16"
                            rx="1"
                          ></rect>
                        </svg>
                      ) : (
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <polygon points="5 3 19 12 5 21 5 3"></polygon>
                        </svg>
                      )}
                    </button>

                    {/* Mute / Unmute Toggle */}
                    <button
                      className="ib-tm-btn-icon"
                      onClick={toggleMute}
                      aria-label={isMuted ? "Unmute Sound" : "Mute Sound"}
                      title={isMuted ? "Unmute" : "Mute"}
                    >
                      {isMuted ? (
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <line x1="1" y1="1" x2="23" y2="23"></line>
                          <path d="M9 9v6a3 3 0 0 0 5.12 2.12M15 9.34V4a2 2 0 0 0-3.28-1.54L7.54 6H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2.54"></path>
                        </svg>
                      ) : (
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>
                          <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>
                        </svg>
                      )}
                    </button>
                  </div>

                  {/* Video Slide Dots */}
                  <div className="ib-tm-dots">
                    {videoTestimonials.map((_, idx) => (
                      <button
                        key={idx}
                        className={`ib-tm-dot ${activeVideoIndex === idx ? "active" : ""}`}
                        onClick={() => setActiveVideoIndex(idx)}
                        aria-label={`Go to video ${idx + 1}`}
                      />
                    ))}
                  </div>

                  {/* Prev / Next Buttons */}
                  <div className="ib-tm-ctrl-group">
                    <button
                      className="ib-tm-btn-icon"
                      onClick={handlePrevVideo}
                      aria-label="Previous Video"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="15 18 9 12 15 6"></polyline>
                      </svg>
                    </button>

                    <button
                      className="ib-tm-btn-icon"
                      onClick={handleNextVideo}
                      aria-label="Next Video"
                    >
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="9 18 15 12 9 6"></polyline>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              {/* RIGHT COLUMN: Google Reviews Slider */}
              <div
                className="ib-tm-reviews-card"
                onMouseEnter={() => setIsReviewAutoPlay(false)}
                onMouseLeave={() => setIsReviewAutoPlay(true)}
              >
                <div
                  class="elfsight-app-948f765b-471e-4c38-a1e6-ae35e2718248"
                  data-elfsight-app-lazy
                ></div>

                {/* <div className="ib-tm-google-header">
              <div className="ib-tm-google-brand">
                
                <svg className="ib-tm-google-logo" viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.06H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.94l2.85-2.22.81-.63z" />
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z" />
                </svg>
                <h3 className="ib-tm-google-title">Google Reviews</h3>
              </div>

              <div className="ib-tm-google-score">
                <span>5.0</span>
                <span>★★★★★</span>
              </div>
            </div>

            
            <div className="ib-tm-review-content">
              <div className="ib-tm-stars">
                {[...Array(activeReview.rating)].map((_, i) => (
                  <svg key={i} width="18" height="18" viewBox="0 0 24 24" fill="#113d48">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                  </svg>
                ))}
              </div>

              <p className="ib-tm-review-text">&ldquo;{activeReview.review}&rdquo;</p>

              <div className="ib-tm-reviewer">
               
                <div className="ib-tm-reviewer-info">
                  <h4 className="ib-tm-reviewer-name">{activeReview.name}</h4>
                  <span className="ib-tm-reviewer-sub">{activeReview.packageType} &bull; {activeReview.timeAgo}</span>
                </div>
              </div>
            </div>

            
            <div className="ib-tm-reviews-footer">
              <div className="ib-tm-verified-badge">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                <span>Verified Google Review</span>
              </div>

              <div className="ib-tm-rev-btn-group">
                <button
                  className="ib-tm-rev-btn"
                  onClick={handlePrevReview}
                  aria-label="Previous Google Review"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>

                <button
                  className="ib-tm-rev-btn"
                  onClick={handleNextReview}
                  aria-label="Next Google Review"
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>
            </div> */}
              </div>
            </div>
          </div>
        </section>
      </>

      <Footer />
      <div id="login-form" className="popup-login-register mfp-hide">
        <ul className="nav" id="pills-tab" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-menu"
              id="pills-home-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-home"
              type="button"
              role="tab"
              aria-controls="pills-home"
              aria-selected="false"
            >
              Login
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className="nav-menu active"
              id="pills-profile-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-profile"
              type="button"
              role="tab"
              aria-controls="pills-profile"
              aria-selected="true"
            >
              Register
            </button>
          </li>
        </ul>
        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="pills-home-tab"
          >
            <h3 className="box-title mb-30">Sign in to your account</h3>
            <div className="th-login-form">
              <form
                action="mail.php"
                method="POST"
                className="login-form ajax-contact"
              >
                <div className="row">
                  <div className="form-group col-12">
                    <label>Username or email</label>
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      id="email"
                      required="required"
                    />
                  </div>
                  <div className="form-group col-12">
                    <label>Password</label>
                    <input
                      type="password"
                      className="form-control"
                      name="pasword"
                      id="pasword"
                      required="required"
                    />
                  </div>
                  <div className="form-btn mb-20 col-12">
                    <button className="th-btn btn-fw th-radius2">
                      Send Message
                    </button>
                  </div>
                </div>
                <div id="forgot_url">
                  <a href="my-account.html">Forgot password?</a>
                </div>
                <p className="form-messages mb-0 mt-3" />
              </form>
            </div>
          </div>
          <div
            className="tab-pane fade active show"
            id="pills-profile"
            role="tabpanel"
            aria-labelledby="pills-profile-tab"
          >
            <h3 className="th-form-title mb-30">Sign in to your account</h3>
            <form
              action="mail.php"
              method="POST"
              className="login-form ajax-contact"
            >
              <div className="row">
                <div className="form-group col-12">
                  <label>Username*</label>
                  <input
                    type="text"
                    className="form-control"
                    name="usename"
                    id="usename"
                    required="required"
                  />
                </div>
                <div className="form-group col-12">
                  <label>First name*</label>
                  <input
                    type="text"
                    className="form-control"
                    name="firstname"
                    id="firstname"
                    required="required"
                  />
                </div>
                <div className="form-group col-12">
                  <label>Last name*</label>
                  <input
                    type="text"
                    className="form-control"
                    name="lastname"
                    id="lastname"
                    required="required"
                  />
                </div>
                <div className="form-group col-12">
                  <label htmlFor="new_email">Your email*</label>
                  <input
                    type="text"
                    className="form-control"
                    name="new_email"
                    id="new_email"
                    required="required"
                  />
                </div>
                <div className="form-group col-12">
                  <label htmlFor="new_email_confirm">Confirm email*</label>
                  <input
                    type="text"
                    className="form-control"
                    name="new_email_confirm"
                    id="new_email_confirm"
                    required="required"
                  />
                </div>
                <div className="statement">
                  <span className="register-notes">
                    A password will be emailed to you.
                  </span>
                </div>
                <div className="form-btn mt-20 col-12">
                  <button className="th-btn btn-fw th-radius2">Sign up</button>
                </div>
              </div>
              <p className="form-messages mb-0 mt-3" />
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
